/**
 * Editor de milestones do Cockpit (faturamento → prêmio coletivo → prêmio líder).
 */

import { Plus, Trash2 } from 'lucide-react'

function MilestonesEditor({ milestones, onChange, disabled = false }) {
  const updateRow = (index, field, rawValue) => {
    const next = milestones.map((row, rowIndex) => {
      if (rowIndex !== index) return row
      return {
        ...row,
        [field]: rawValue,
      }
    })
    onChange(next)
  }

  const removeRow = (index) => {
    if (milestones.length <= 1) return
    onChange(milestones.filter((_, rowIndex) => rowIndex !== index))
  }

  const addRow = () => {
    const last = milestones[milestones.length - 1]
    const nextValue = last ? Number(last.value) + 10000 : 10000
    onChange([
      ...milestones,
      { value: nextValue, prize: 0, top_seller_prize: 0 },
    ])
  }

  return (
    <div className="milestones-editor">
      <div className="milestones-editor-table-wrap">
        <table className="milestones-editor-table">
          <thead>
            <tr>
              <th>Faturamento (R$)</th>
              <th>Prêmio geral (R$)</th>
              <th>Prêmio líder (R$)</th>
              <th aria-label="Ações" />
            </tr>
          </thead>
          <tbody>
            {milestones.map((row, index) => (
              <tr key={`milestone-${index}`}>
                <td>
                  <input
                    type="number"
                    min={1}
                    step={1000}
                    className="cockpit-settings-input"
                    value={row.value}
                    disabled={disabled}
                    onChange={(e) => updateRow(index, 'value', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    min={0}
                    step={10}
                    className="cockpit-settings-input"
                    value={row.prize}
                    disabled={disabled}
                    onChange={(e) => updateRow(index, 'prize', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    min={0}
                    step={10}
                    className="cockpit-settings-input"
                    value={row.top_seller_prize ?? ''}
                    disabled={disabled}
                    onChange={(e) => updateRow(index, 'top_seller_prize', e.target.value)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="milestones-editor-remove-btn"
                    onClick={() => removeRow(index)}
                    disabled={disabled || milestones.length <= 1}
                    aria-label="Remover marco"
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        className="milestones-editor-add-btn"
        onClick={addRow}
        disabled={disabled}
      >
        <Plus size={16} />
        Adicionar marco
      </button>
    </div>
  )
}

export default MilestonesEditor
